
import { AuthRepository } from "../../domain/repository/auth_repository";
import { AuthenticationApiService } from "../data_source/remote/authentication_api_service";

export class AuthRepositoryImpl implements AuthRepository {
    private authApiService: AuthenticationApiService;

    constructor() {
        this.authApiService = new AuthenticationApiService();
    }

    async sendVerificationEmail(email: string): Promise<void> {
        await this.authApiService.sendVerificationEmail(email);
    }
}